/* eslint-disable @typescript-eslint/ban-types */
export var PopupVariant;
(function (PopupVariant) {
    PopupVariant["Primary"] = "primary";
    PopupVariant["Secondary"] = "secondary";
    PopupVariant["Success"] = "success";
    PopupVariant["Danger"] = "danger";
    PopupVariant["Warning"] = "warning";
    PopupVariant["Info"] = "info";
    PopupVariant["Light"] = "light";
    PopupVariant["Dark"] = "dark";
})(PopupVariant || (PopupVariant = {}));
